const shouldShowImperial = () => {
  // Some local markets want to hide the user's option to use Imperial measurements.
  const hideImperialForLangs = [
    'de_DE',
    'fr_CH',
    'it_IT',
    'cs_CZ',
    'hr_HR',
    'sr',
  ];
  if (window && window.lxl_current_lang && window.lxl_current_lang.locale) {
    const currentLang = window.lxl_current_lang.locale;
    return !hideImperialForLangs.includes(currentLang);
  }
  return true;
};

export default shouldShowImperial;
